module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v("11")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_c('span', [_vm._v("Laß dies")]), _vm._v(" Stimmen und\nSingen und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nSagen des Rosenkranzes! Wen betest du"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nan in diesem einsamen, dunklen Winkel"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndes Tempels, in dem verschlossenen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nTor?")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Öffne die Augen und sieh, dein Gott"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nist nicht vor dir.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Er ist dort, wo der Pflüger den harten"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nGrund pflügt, wo der Steinklopfer Steine"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nbricht. Er ist mit ihnen in Sonne und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nRegen und wo sein Kleid bedeckt ist mit"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nStaub. Leg ab deinen heiligen Mantel und"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nkomme herab mit ihm auf den staubigen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nBoden.")]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Befreiung? Wo ist die Befreiung zu"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nfinden? Unser Meister hat freudig die"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nBande der Schöpfung auf sich genommen;"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ner ist mit uns für immer gebunden. "), _c('a', {
    attrs: {
      "id": "page14",
      "title": "mabarosa/wedi"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "vers"
  }, [_vm._v("Komm heraus aus deiner Betrachtung,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nlaß Blumen und Weihrauch beiseite! Was"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nschadet es, wenn deine Kleider zerreißen"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nund fleckig werden. Geh ihm entgegen,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\nstehe bei ihm in der Arbeit, dem Schweiß"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("\ndeiner Stirne. "), _c('a', {
    attrs: {
      "id": "page15",
      "title": "mabarosa/wedi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2ce28d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0012.vue
// module id = 90
// module chunks = 0